import { Settings } from "@carbon/icons-react";
import { ModDashboardConfig, ModerationSettingsPage } from "open-modules/zdf/structure/moddashboard";
import { Feature } from "util/stdtypes";

export type ModDashboardSettingsConfig = {
    channelSettingsEnabled: boolean;
};

export const ModDashboardSettingsFeature: Feature<ModDashboardSettingsConfig & ModDashboardConfig> = {
    name: "Settings Tab",
    key: "moddashboardsettings",
    providesConfig: {
        moderationPages: [
            {
                id: "page-settings",
                label: "Settings",
                icon: Settings,
                component: ModerationSettingsPage,
            },
        ],
    },
    receivesConfigDefaults: {
        channelSettingsEnabled: false,
    },
};